// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-banners-banner-standard-item-nytlk{transition:all .1s ease-in-out;border-radius:12px;display:block;overflow:hidden;position:relative}.components-banners-banner-standard-item-nytlk:hover{box-shadow:0 6px 16px 0 rgba(0,0,0,.12)}.components-banners-banner-standard-image-rwlxz{transition:all .1s ease-in-out}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "components-banners-banner-standard-item-nytlk",
	"image": "components-banners-banner-standard-image-rwlxz"
};
module.exports = ___CSS_LOADER_EXPORT___;
